import * as React from 'react';

export interface UnityViewProps {
  canvas: string;
  height: string;
  width: string;
}

export function UnityView({ canvas, height, width }: UnityViewProps) {
  return <div id={canvas} style={{ width, height }} />;
}
